import type * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubjectLibrarySubjectsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.SubjectFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort?: Types.InputMaybe<Array<Types.InputMaybe<Types.SubjectSortInput>> | Types.InputMaybe<Types.SubjectSortInput>>;
}>;


export type SubjectLibrarySubjectsQuery = { __typename?: 'RootQueryType', subjects?: { __typename?: 'KeysetPageOfSubject', count?: number | null, endKeyset?: string | null, results?: Array<{ __typename?: 'Subject', id: string, name: string, urlSlug: string, description?: string | null, logoImageUrl?: string | null, badge?: string | null, subscriptionsPrices?: Array<any> | null, curriculumArea?: { __typename?: 'CurriculumArea', id: string, color: string, name: string } | null, guides: Array<{ __typename?: 'Guide', id: string, type: string }> }> | null } | null };


export const SubjectLibrarySubjectsDocument = gql`
    query SubjectLibrarySubjects($filter: SubjectFilterInput, $first: Int, $after: String, $sort: [SubjectSortInput]) {
  subjects(filter: $filter, first: $first, after: $after, sort: $sort) {
    count
    endKeyset
    results {
      id
      name
      urlSlug
      description
      logoImageUrl
      badge
      subscriptionsPrices
      curriculumArea {
        id
        color
        name
      }
      guides {
        id
        type
      }
    }
  }
}
    `;

/**
 * __useSubjectLibrarySubjectsQuery__
 *
 * To run a query within a React component, call `useSubjectLibrarySubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubjectLibrarySubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubjectLibrarySubjectsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSubjectLibrarySubjectsQuery(baseOptions?: Apollo.QueryHookOptions<SubjectLibrarySubjectsQuery, SubjectLibrarySubjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubjectLibrarySubjectsQuery, SubjectLibrarySubjectsQueryVariables>(SubjectLibrarySubjectsDocument, options);
      }
export function useSubjectLibrarySubjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubjectLibrarySubjectsQuery, SubjectLibrarySubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubjectLibrarySubjectsQuery, SubjectLibrarySubjectsQueryVariables>(SubjectLibrarySubjectsDocument, options);
        }
// @ts-ignore
export function useSubjectLibrarySubjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubjectLibrarySubjectsQuery, SubjectLibrarySubjectsQueryVariables>): Apollo.UseSuspenseQueryResult<SubjectLibrarySubjectsQuery, SubjectLibrarySubjectsQueryVariables>;
export function useSubjectLibrarySubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubjectLibrarySubjectsQuery, SubjectLibrarySubjectsQueryVariables>): Apollo.UseSuspenseQueryResult<SubjectLibrarySubjectsQuery | undefined, SubjectLibrarySubjectsQueryVariables>;
export function useSubjectLibrarySubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubjectLibrarySubjectsQuery, SubjectLibrarySubjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubjectLibrarySubjectsQuery, SubjectLibrarySubjectsQueryVariables>(SubjectLibrarySubjectsDocument, options);
        }
export type SubjectLibrarySubjectsQueryHookResult = ReturnType<typeof useSubjectLibrarySubjectsQuery>;
export type SubjectLibrarySubjectsLazyQueryHookResult = ReturnType<typeof useSubjectLibrarySubjectsLazyQuery>;
export type SubjectLibrarySubjectsSuspenseQueryHookResult = ReturnType<typeof useSubjectLibrarySubjectsSuspenseQuery>;
export type SubjectLibrarySubjectsQueryResult = Apollo.QueryResult<SubjectLibrarySubjectsQuery, SubjectLibrarySubjectsQueryVariables>;